import {
  styles
} from "./chunk-IJAAAKZQ.mjs";

// src/slider.dom.ts
import { createScope } from "@zag-js/dom-query";
import { getRelativePointValue } from "@zag-js/dom-event";
import { dispatchInputValueEvent } from "@zag-js/form-utils";
import { getPercentValue } from "@zag-js/numeric-range";
var dom = createScope({
  ...styles,
  getRootId: (ctx) => ctx.ids?.root ?? `slider:${ctx.id}`,
  getThumbId: (ctx) => ctx.ids?.thumb ?? `slider:${ctx.id}:thumb`,
  getControlId: (ctx) => ctx.ids?.control ?? `slider:${ctx.id}:control`,
  getHiddenInputId: (ctx) => `slider:${ctx.id}:input`,
  getOutputId: (ctx) => ctx.ids?.output ?? `slider:${ctx.id}:output`,
  getTrackId: (ctx) => ctx.ids?.track ?? `slider:${ctx.id}track`,
  getRangeId: (ctx) => ctx.ids?.track ?? `slider:${ctx.id}:range`,
  getLabelId: (ctx) => ctx.ids?.label ?? `slider:${ctx.id}:label`,
  getMarkerId: (ctx, value) => `slider:${ctx.id}:marker:${value}`,
  getRootEl: (ctx) => dom.getById(ctx, dom.getRootId(ctx)),
  getThumbEl: (ctx) => dom.getById(ctx, dom.getThumbId(ctx)),
  getControlEl: (ctx) => dom.getById(ctx, dom.getControlId(ctx)),
  getHiddenInputEl: (ctx) => dom.getById(ctx, dom.getHiddenInputId(ctx)),
  getValueFromPoint(ctx, point) {
    const el = dom.getControlEl(ctx);
    if (!el)
      return;
    const relativePoint = getRelativePointValue(point, el);
    const percentX = relativePoint.x / el.offsetWidth;
    const percentY = relativePoint.y / el.offsetHeight;
    let percent;
    if (ctx.isHorizontal) {
      percent = ctx.isRtl ? 1 - percentX : percentX;
    } else {
      percent = 1 - percentY;
    }
    return getPercentValue(percent, ctx.min, ctx.max, ctx.step);
  },
  dispatchChangeEvent(ctx) {
    const input = dom.getHiddenInputEl(ctx);
    if (!input)
      return;
    dispatchInputValueEvent(input, ctx.value);
  }
});

export {
  dom
};
